/**
 * Generic listener management for session request lifecycle events
 */
export default class ListenerBus {
    constructor() {
        this.listeners = new Map();
        this.listeners.set('queued', []);
        this.listeners.set('willSend', []);
        this.listeners.set('sent', []);
    }
    /**
     * Add a listener for a specific event type
     * @param eventType - Event type ('queued', 'willSend', 'sent')
     * @param callback - Callback function
     */
    addListener(eventType, callback) {
        if (callback && typeof callback === 'function') {
            const listeners = this.listeners.get(eventType);
            if (listeners) {
                listeners.push(callback);
            }
        }
    }
    /**
     * Fire all listeners for a specific event type
     * @param eventType - Event type
     * @param request - Request to pass to listeners
     */
    fireListeners(eventType, request) {
        const listeners = this.listeners.get(eventType);
        if (listeners) {
            listeners.forEach((listener) => {
                if (listener && typeof listener === 'function') {
                    try {
                        listener(request);
                    }
                    catch (e) {
                        // Silently catch listener errors to prevent breaking the flow
                    }
                }
            });
        }
    }
    /**
     * Get all listeners for a specific event type (for legacy compatibility)
     * @param eventType - Event type
     */
    getListeners(eventType) {
        return this.listeners.get(eventType) || [];
    }
    /**
     * Clear all listeners
     */
    clear() {
        this.listeners.forEach((list) => list.splice(0, list.length));
    }
}
